// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"445e5858","194":"1a00035e","309":"1f6b8ae9","318":"660a1550","453":"2105adcc","552":"bc7e4f44","719":"5eca29e4","724":"618e9488","796":"2aa34381","804":"b567702e","867":"390b68a1"}[chunkId] + ".chunk.js";
};